module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0110.jpg?v=2ae5cbe7";